import React from "react";
import { extent, max } from "d3-array";
import { scaleLinear } from "d3-scale";

import Localization from "../Localization";
import { formatAs } from "../settings.js";

export default function CountryTooltip(props) {
  const { name, bars } = props.data;
  const minMaxYears = extent(props.selectedYears);
  const yearString =
    minMaxYears[0] === minMaxYears[1] ? minMaxYears[0] : minMaxYears.join("-");

  // the last group represents the bar "cap" and doesn't contain data, ignore that one.
  const barsToConsider = bars.slice(0, bars.length - 1);

  const graphWidth = 340;
  const rowHeight = 40;
  const graphHeight = rowHeight * barsToConsider.length;
  const rightMargin = 100;
  const width = graphWidth - rightMargin;
  const maxValue = max(barsToConsider, (d) => d.count);
  const xScale = scaleLinear().domain([0, maxValue]).range([0, width]);
  const barHeight = rowHeight / 2;

  return (
    <div className="tooltip countryTooltip">
      <div className="tooltipTitle">
        {Localization.getLanguage() === "zh"
          ? Localization.get(name.toUpperCase())
          : name}
        , {yearString}
      </div>
      <div className="content">
        <svg width={graphWidth} height={graphHeight}>
          {barsToConsider.map((group, groupIndex) => {
            const rectWidth = xScale(group.count);
            const y = rowHeight * groupIndex;
            return (
              <g key={group.name} transform={`translate(0, ${y})`}>
                <rect width={rectWidth} height={barHeight} fill={group.color} />
                <text x={rectWidth + 5}>
                  {formatAs.number(group.count)}{" "}
                  {props.valueKey === "co2emissions"
                    ? Localization.get("K Ton")
                    : "MW"}
                </text>
                <text y={barHeight + 2} className="groupLabel">
                  {Localization.get(group.name)}
                </text>
              </g>
            );
          })}
        </svg>
      </div>
    </div>
  );
}
